import { render, staticRenderFns } from "./EditTaskMenu.vue?vue&type=template&id=d689341e&scoped=true"
import script from "./EditTaskMenu.vue?vue&type=script&lang=js"
export * from "./EditTaskMenu.vue?vue&type=script&lang=js"
import style0 from "./EditTaskMenu.vue?vue&type=style&index=0&id=d689341e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d689341e",
  null
  
)

export default component.exports